import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Challenge } from 'src/types/shared/Challenge';

export const fetchSingleChallengeRequest = createAction('fetchSingleChallengeRequest');
export const fetchSingleChallengeSuccess = createAction<Challenge>('fetchSingleChallengeSuccess');
export const fetchSingleChallengeFailure = createAction('fetchSingleChallengeFailure');

export const fetchSingleChallenge = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchSingleChallengeRequest());
    try {
        const { data } = await api.get<Challenge>('admin/challenges/' + id);
        dispatch(fetchSingleChallengeSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchSingleChallengeFailure, e);
    }
};
